import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import RecipeDetail from './pages/RecipeDetail';
import CategoryPage from './pages/CategoryPage';
import Vegetarian from './pages/category/Vegetarian';
import Desserts from './pages/category/Desserts';
import About from './pages/About';
import Contact from './pages/Contact';
import Pasta from './pages/category/Pasta';
import Popular from './pages/category/Popular';
import RecipeFoodCard from './components/RecipeFoodCard';

function App() {
  return (
    <div className="app">
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/recipe/:id" element={<RecipeDetail />} />
          <Route path="/food-card/:id" element={<RecipeFoodCard />} />
          <Route path="/category/:category" element={<CategoryPage />} />
          <Route path="/category/vegetarian" element={<Vegetarian />} />
          <Route path="/category/desserts" element={<Desserts />} />
          <Route path="/category/pasta" element={<Pasta />} />
          <Route path="/category/popular" element={<Popular />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
